import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { appealApi } from '../../api/appealApi';
import { FileText, ArrowLeft, Check, Upload, X, ClipboardList,Eye } from 'lucide-react';
import { useToast } from '../../components/Toast';
import { isApiConfigured } from '../../api/axiosClient';
import {
    LoadingSpinner,
    ErrorCard
} from '../../components/LoadingSpinner';
import { validators, formatters } from '../../utils/validators';

import AttachmentPreviewDialog from "./appeal/AttachmentPreviewDialog";

/**
 * Claim Appeal / Reconsideration form.
 * Route: /claims/:id/appeal — reached from the "File Appeal" button on the Claim
 * Detail page (prefilled via location.state). Portal-themed, mirrors the
 * EnrollmentPage pattern: validate → submit (appealApi, live-or-mock) → receipt.
 */

const C = {
  primary: '#0D9488', dark: '#0F766E', ink: '#0F172A', muted: '#64748B', faint: '#94A3B8',
  border: '#E8ECF0', borderStrong: '#CBD5E1', bgInput: '#F8FAFB', required: '#DC2626',
  success: '#059669', successTint: '#ECFDF5',
};

const REASONS = [
  'Incorrect denial', 'Medical necessity', 'Coding correction', 'Timely filing',
  'Coordination of benefits (COB)', 'Underpayment', 'Other',
];

const inputStyle = { width: '100%', background: C.bgInput, border: `1px solid ${C.border}`, borderRadius: 10, padding: '10px 12px', font: 'inherit', fontSize: 14, color: C.ink, outline: 'none' };
const labelStyle = { fontSize: 13, fontWeight: 600, color: C.muted, display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 };
const Req = () => <span style={{ color: C.required, fontWeight: 800 }}>*</span>;

export default function AppealPage() {
  const navigate = useNavigate();
    const location = useLocation();
  const [searchParams] = useSearchParams();
    const { id } = useParams();

    const { aid, uid } = useParams();
    const { user } = useAuth();
    const toast = useToast();
    const pre = location.state || {};

   //alert(JSON.stringify(pre));

  //const [claimNumber, setClaimNumber] = useState(pre.claimNumber || '');
    const [claimNumber, setClaimNumber] = useState(String(pre.claimNumber ?? ''));
  const [memberName, setMemberName] = useState(pre.memberName || '');
  const [memberId, setMemberId] = useState(pre.memberId || '');
  const [status] = useState(pre.claimStatus || pre.status || '');
  const [reason, setReason] = useState('');
  const [justification, setJustification] = useState('');
  const [outcome, setOutcome] = useState('');
  const [contactEmail, setContactEmail] = useState(user?.email || '');
    const [contactPhone, setContactPhone] = useState(user?.phone || '');
    const [provider, setProvider] = useState({});
    
  const [files, setFiles] = useState([]); // File[]
  const [agree, setAgree] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
    const [receipt, setReceipt] = useState(null);

    //const [appealId, setAppealId] = useState(searchParams.get('aid'));
    //const [userId, setUserId] = useState(searchParams.get('uid')|| pre.selectedUserId);


    const [appealId, setAppealId] = useState(aid);
    const [userId, setUserId] = useState(uid || pre.selectedUserId);

    const [removedAttachmentIds, setRemovedAttachmentIds] = useState([]);
    const [pageLoading, setPageLoading] =
        useState(false);

    const [previewAttachment, setPreviewAttachment] =
        useState(null);

    const [previewDialogOpen, setPreviewDialogOpen] =
        useState(false);

  //const org = user?.orgName || user?.organizationName || '';
    const org = pre?.providerName || '';
  const npi = user?.npi || '';
    //const tin = user?.taxId || '';
    const tin = pre?.federalId || '';


    const getAppeal = async (appealId) => {
       // alert("HIT1 : "+appealId);

        if (!isApiConfigured()) {
            return;
        }

        setPageLoading(true);

        try {

            const res =
                await appealApi.getAppeal({
                    appealId: appealId
                });

            //alert(JSON.stringify(res));

           // console.log(JSON.stringify(res));
            if (res.success)
            {
                
                const data = res.data;
              //  alert("JSON :"+JSON.stringify(data));

                setClaimNumber(data.ClaimNumber?.trim() || "");
                setMemberName(data.MemberName?.trim() || "");
                setMemberId(data.MemberId?.trim() || "");
                setReason(data.Reason?.trim() || "");
                setJustification(data.Justification?.trim() || "");
                setOutcome(data.RequestedOutcome?.trim() || "");
                setContactEmail(data.ContactEmail?.trim() || "");
                setContactPhone(data.ContactPhone?.trim() || "");
                setProvider({
                    name: data.ProviderName?.trim() || "",
                    npi: data.NPI?.trim() || "",
                    tin: data.TIN?.trim() || "",
                });
                

                const existingAttachments = (data.Attachments || []).map((attachment) => ({ name: attachment.OriginalFileName, size: attachment.FileSize, type: attachment.ContentType, attachmentId: attachment.AppealAttachmentId, previewUrl: attachment.PreviewUrl, downloadUrl: attachment.DownloadUrl, canPreview: attachment.CanPreview, isExisting: true, }));
                setFiles(existingAttachments);
                



            } else {
                
                toast.warning(res.message, { title: 'Claim Appeal' });
                
                

                console.log(res.message);

            }

        } catch (err) {

            console.log(
                'Error at getAppeal : ' +
                err
            );

        } finally {

            setPageLoading(false);

        }

    };

    //const appealId = searchParams.get('aid');


    useEffect(() => {
        if (!appealId) return;
        const loadAppealData = async (appealId) => {          

            await Promise.all([
                getAppeal(appealId)                
            ]);            
        };

        loadAppealData(appealId);


    }, [appealId]);

  const onFiles = (e) => {
    const picked = Array.from(e.target.files || []);
    setFiles((prev) => [...prev, ...picked].slice(0, 10));
    e.target.value = '';
  };
    //const removeFile = (i) => setFiles((prev) => prev.filter((_, idx) => idx !== i));

    const removeFile = (i) => {
        setFiles((prev) => {
            const file = prev[i];

            // Existing attachment from API
            if (file?.isExisting && file?.attachmentId) {
                setRemovedAttachmentIds((ids) => [
                    ...ids,
                    file.attachmentId
                ]);
            }

            return prev.filter((_, idx) => idx !== i);
        });
    };

    const handlePreviewAttachment = (attachment) => {
        setPreviewAttachment(attachment);
        setPreviewDialogOpen(true);
    };
    const handleClosePreview = () => {
        setPreviewDialogOpen(false);
        setPreviewAttachment(null);
    };
    const iconBtn = (color) => ({
        width: 30,

        height: 30,

        borderRadius: 8,

        border: `1px solid ${color}33`,

        background: `${color}0A`,

        color,

        cursor: "pointer",

        display: "inline-flex",

        alignItems: "center",

        justifyContent: "center",

        padding: 0,
    });


    const submit = async () => {
        //toast.success("This feature is currently under development and will be available soon. Thank you for your patience.", { title: 'Claim Appeal' });
        //return;
        
    if (!claimNumber?.trim()) { setError('Enter the claim number being appealed.'); return; }
    if (!reason) { setError('Select a reason for the appeal.'); return; }
    if (!justification.trim() || justification.trim().length < 20) { setError('Add a justification (at least 20 characters).'); return; }
    if (!agree) { setError('Please check the attestation before submitting.'); return; }
        setError(''); setBusy(true);



    try {
      const payload = {
        claimNumber: claimNumber?.trim(),
        claimId: id,
        memberName: memberName?.trim(),
        memberId: memberId?.trim(),
        provider: { name: org, npi, tin },
        reason,
        justification: justification?.trim(),
        requestedOutcome: outcome?.trim(),
        contact: { email: contactEmail?.trim(), phone: contactPhone?.trim() },
          //documents: files.map((f) => f.name),
          documents: files,
          //userId:user?.userId
          //userId: user?.userRole?.trim().toLowerCase() === 'super admin' ? userId : user?.userId
          userId: ["super admin", "admin"].includes(
              user?.userRole?.trim().toLowerCase()
          ) ? userId : user?.userId

      };
             

        const filesArray = Array.from(files);

        const allowedTypes = [
            'image/png',
            'image/jpeg',
            'application/pdf'
        ];

        const MAX_FILE_SIZE = 5 * 1024 * 1024;   // 5 MB
        const MAX_TOTAL_SIZE = 25 * 1024 * 1024; // 25 MB

        // Maximum 5 files
        if (filesArray.length > 5) {
            setError('You can upload a maximum of 5 files.');
            return;
        }

        // Check file type
        const invalidFiles = filesArray.filter(
            file => !allowedTypes.includes(file.type)
        );

        if (invalidFiles.length > 0) {
            setError('Only PNG, JPG, JPEG, and PDF files are allowed.');
            return;
        }

        // Check individual file size
        const oversizedFile = filesArray.find(
            file => file.size > MAX_FILE_SIZE
        );

        if (oversizedFile) {
            setError(`"${oversizedFile.name}" exceeds the 5 MB file size limit.`);
            return;
        }

        // Check total upload size
        const totalSize = filesArray.reduce(
            (total, file) => total + file.size,
            0
        );

        if (totalSize > MAX_TOTAL_SIZE) {
            setError('The total size of all uploaded files cannot exceed 25 MB.');
            return;
        }

        
        

        if (appealId)
        {

           
            //update existing appeal
            const updatedPayload = {
                ...payload,
                provider: {name:provider.name,npi:provider.npi,tin:provider.tin},
                removedAttachmentIds,
                appealId
            };
            const res = await appealApi.updateAppeal(updatedPayload);

            if (res.success) {   

                //load appeal data
                await getAppeal(appealId);  
                toast.success(
                    res.message,
                    {
                        title: 'Claim Appeal Update'
                    }
                );
            }
            else {
                toast.warning(
                    res.message,
                    {
                        title: 'Claim Appeal Update'
                    }
                );
            }
        }
        else
        {
          
            //submit new  appeal
            const res = await appealApi.submitAppeal(payload);

            if (res.success) {

                const data = res?.data || {};
                setReceipt({
                    appealNumber: data?.AppealNumber || '(pending)',
                    submittedAt: data?.SubmittedDate || new Date().toISOString(),
                    claimNumber: data?.ClaimNumber,
                    reason: payload?.reason,
                });
                toast.success(
                    res.message,
                    {
                        title: 'Claim Appeal Submit'
                    }
                );
            }
            else {
                toast.warning(
                    res.message,
                    {
                        title: 'Claim Appeal Submit'
                    }
                );
            }
        }
        
        
      
    } catch (err) {
      setError(err?.response?.data?.message || err?.message || 'Could not submit the appeal. Please try again.');
    } finally { setBusy(false); }
  };

  if (receipt) {
    return (
        <div className="main-content">

            
        <div className="page-header"><div><h1>Appeal Submitted</h1></div></div>
        <div className="card" style={{ borderColor: C.success, background: C.successTint }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontWeight: 800, fontSize: 16, color: '#047857', marginBottom: 12 }}>
            <Check size={20} strokeWidth={2.6} /> Appeal received
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '6px 16px', fontSize: 14, color: C.ink, maxWidth: 520 }}>
            <div style={{ color: C.muted }}>Appeal number</div><div style={{ fontWeight: 700 }}>{receipt.appealNumber}</div>
            <div style={{ color: C.muted }}>Claim</div><div>{receipt.claimNumber}</div>
            <div style={{ color: C.muted }}>Reason</div><div>{receipt.reason}</div>
            <div style={{ color: C.muted }}>Submitted</div><div>{new Date(receipt.submittedAt).toLocaleString()}</div>
            <div style={{ color: C.muted }}>Status</div><div><span style={{ background: '#FEF3C7', color: '#B45309', padding: '2px 10px', borderRadius: 20, fontSize: 12, fontWeight: 700 }}>Submitted — pending review</span></div>
          </div>
          <p style={{ fontSize: 13.5, color: C.muted, marginTop: 14 }}>Keep the appeal number for reference. You’ll be notified when the decision is made.</p>
          <div style={{ display: 'flex', gap: 10, marginTop: 12, flexWrap: 'wrap' }}>
            <button className="btn-primary" onClick={() => navigate('/appeals')} style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><ClipboardList size={15} /> View My Appeals</button>
            <button className="btn-secondary" onClick={() => navigate('/claims')}>Back to Claims</button>
          </div>
        </div>
      </div>
    );
  }

  return (
      <div className="main-content">
          {pageLoading && (

              <div style={styles.overlay}>

                  <LoadingSpinner
                      data-cy="page-loader-profile"
                      message="Please wait..."
                      fullPage="true"
                  />

              </div>

          )}
      <div className="page-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <button className="btn-secondary" onClick={() => navigate(-1)} style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><ArrowLeft size={16} /> Back</button>
          <div>
            <h1>File a Claim Appeal</h1>
            <p style={{ margin: '4px 0 0', color: C.muted, fontSize: 14 }}>Request reconsideration of a claim decision. Fields marked <Req /> are required.</p>
          </div>
        </div>
      </div>

      {/* Claim + member */}
      <div className="card">
        <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: 700, color: C.ink }}>Claim being appealed</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(12,1fr)', gap: '14px 18px' }}>
          <div style={{ gridColumn: 'span 4' }}>
            <label style={labelStyle}>Claim number <Req /></label>
            <input style={inputStyle} value={claimNumber} onChange={(e) => setClaimNumber(e.target.value)} placeholder="CLM-2026-0112" />
          </div>
          <div style={{ gridColumn: 'span 5' }}>
            <label style={labelStyle}>Member name</label>
            <input style={inputStyle} value={memberName} onChange={(e) => setMemberName(e.target.value)} placeholder="Member name" />
          </div>
          <div style={{ gridColumn: 'span 3' }}>
            <label style={labelStyle}>Member ID</label>
            <input style={inputStyle} value={memberId} onChange={(e) => setMemberId(e.target.value)} placeholder="Member ID" />
          </div>
          {status && (
            <div style={{ gridColumn: 'span 12', fontSize: 13, color: C.muted }}>
              Current claim status: <b style={{ color: status === 'Denied' ? C.required : C.ink }}>{status}</b>
            </div>
          )}
        </div>
      </div>

      {/* Appeal detail */}
      <div className="card">
        <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: 700, color: C.ink }}>Appeal details</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(12,1fr)', gap: '14px 18px' }}>
          <div style={{ gridColumn: 'span 5' }}>
            <label style={labelStyle}>Reason for appeal <Req /></label>
            <select style={inputStyle} value={reason} onChange={(e) => setReason(e.target.value)}>
              <option value="">Select a reason…</option>
              {REASONS.map((r) => <option key={r}>{r}</option>)}
            </select>
          </div>
          <div style={{ gridColumn: 'span 7' }}>
            <label style={labelStyle}>Requested outcome</label>
            <input style={inputStyle} value={outcome} onChange={(e) => setOutcome(e.target.value)} placeholder="e.g. Reprocess and pay per contracted rate" />
          </div>
          <div style={{ gridColumn: 'span 12' }}>
            <label style={labelStyle}>Justification <Req /></label>
            <textarea style={{ ...inputStyle, resize: 'vertical' }} rows={4} value={justification} onChange={(e) => setJustification(e.target.value)} placeholder="Explain why the claim should be reconsidered — reference the denial reason (CARC/RARC), corrected coding, medical necessity, etc." />
          </div>
          <div style={{ gridColumn: 'span 12' }}>
            <label style={labelStyle}>Supporting documents</label>
            <label style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '9px 14px', borderRadius: 10, border: `1px dashed ${C.borderStrong}`, background: C.bgInput, color: C.dark, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
              <Upload size={15} /> Add files
              <input type="file" multiple onChange={onFiles} style={{ display: 'none' }} />
            </label>
            {files.length > 0 && (
              <div style={{ marginTop: 10, display: 'flex', flexDirection: 'column', gap: 6 }}>
                {files.map((f, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: C.ink }}>
                    <FileText size={14} color={C.muted} /> <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.name}</span>
                        {/*<button onClick={() => removeFile(i)} title="Remove" style={{ border: 'none', background: 'transparent', color: C.faint, cursor: 'pointer', display: 'inline-flex' }}><X size={15} /></button>*/}

                        {/* Preview button - only for existing files */}
                        {f.attachmentId && (<button onClick={() => { f.AppealAttachmentId = f.attachmentId; f.OriginalFileName = f.name; f.ContentType = f.type; handlePreviewAttachment(f); }} title="Preview attachment" style={iconBtn("#0D9488")} > <Eye size={13} strokeWidth={2.5} /> </button>)}

                        {/* Remove button - available for all files */}
                        <button
                            onClick={() => removeFile(i)}
                            title="Remove attachment"
                            style={iconBtn("#DC2626")}
                        >
                            <X
                                size={13}
                                strokeWidth={2.5}
                            />
                        </button>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div style={{ gridColumn: 'span 6' }}>
            <label style={labelStyle}>Contact email</label>
            <input style={inputStyle} type="email" value={contactEmail} onChange={(e) => setContactEmail(e.target.value)} placeholder="billing@clinic.example" />
          </div>
          <div style={{ gridColumn: 'span 6' }}>
            <label style={labelStyle}>Contact phone</label>
            <input style={inputStyle} value={contactPhone} onChange={(e) => setContactPhone(formatters.phone(e.target.value))} placeholder="(512) 555-0000" />
          </div>
        </div>
      </div>

      {/* Submit */}
      <div className="card" style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
        <label style={{ display: 'flex', alignItems: 'flex-start', gap: 9, fontSize: 13, color: C.muted, maxWidth: 620, cursor: 'pointer' }}>
          <input type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} style={{ marginTop: 3 }} />
          I certify the information is accurate and I am authorized to submit this appeal on behalf of { provider ? provider.name  : org || 'the provider'} (NPI {npi || '—'}).
        </label>
        <span style={{ flex: 1 }} />
        <button className="btn-primary" disabled={busy} onClick={submit}>{busy ? 'Submitting…' : 'Submit appeal'}</button>
      </div>
          {error && <div style={{ color: C.required, fontSize: 13, fontWeight: 600, marginTop: -8 }}>{error}</div>}

          <AttachmentPreviewDialog
              open={previewDialogOpen}
              attachment={previewAttachment}
              onClose={handleClosePreview}
          />
    </div>
  );
}


/*
 * Page loading overlay
 */
const styles = {

    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background:
            'rgba(255,255,255,0.7)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }

};